const LWC_SHOP_URL = 'http://www.lendwithcareshop.org/'

export default function ({ route }) {
  if (route.path === '/info/about-us/lendwithcare-shop') {
    window.location.replace(LWC_SHOP_URL)
  }
}
